import { Process } from './store/process.model';

const EFAACT_STORE_PROCESS: Process = {
    ProcessID: -11,
    ProcessName: 'eFAACT Store',
    RouteName: 'efaactstore',
    ProcessDesc: 'eFAACT Store',
    ProcessTitle: 'eFAACT Store'
};

/** Routes registered in the app shell but not returned in UserProcesses. */
const SYSTEM_ROUTE_PROCESSES: Record<string, Process> = {
    efaactstore: EFAACT_STORE_PROCESS
};

export function normalizeInitialRouteName(
    routeName: string | undefined | null
): string | undefined {
    const trimmed = routeName?.trim();
    if (!trimmed) {
        return undefined;
    }

    const normalized = trimmed.replace(/^\/+/, '').toLowerCase();
    return normalized || undefined;
}

export function hasInitialRouteRedirect(
    routeName: string | undefined | null
): boolean {
    return !!normalizeInitialRouteName(routeName);
}

export function resolveSystemRouteProcess(
    routeName: string | undefined | null
): Process | undefined {
    const normalized = normalizeInitialRouteName(routeName);
    if (!normalized) {
        return undefined;
    }

    const process = SYSTEM_ROUTE_PROCESSES[normalized];
    return process ? { ...process } : undefined;
}

export function getSystemRouteStateName(
    routeName: string | undefined | null
): string | undefined {
    const normalized = normalizeInitialRouteName(routeName);
    if (!normalized || !SYSTEM_ROUTE_PROCESSES[normalized]) {
        return undefined;
    }

    return normalized;
}

export function resolveInitialRouteStateName(
    routeName: string | undefined | null
): string | undefined {
    return getSystemRouteStateName(routeName) ?? normalizeInitialRouteName(routeName);
}
